import apiClient from '@/api/apiClient';

const authService = {

    async setVeterinaria(user_id) {
        try {
            const response = await apiClient.get(`/employee/get-vet-by-user_id/${user_id}`);
            return response.data.data;
        } catch (error) {
            console.error('Error setting veterinaria:', error);
            if(error.response.status !== 500) {
                return null; // Return null if the error is not a server error
            }
            throw error;
        }
    }
}

export default authService;